<h3 class="mb-4">Purchasing Dashboard</h3>

@if (metrics) {
    <div class="row g-3 mb-4">
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Total Purchase Orders</div>
                    <div class="fs-3 fw-bold">{{ metrics.totalOrders }}</div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Open Orders</div>
                    <div class="fs-3 fw-bold">{{ metrics.openOrders }}</div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Total Order Value</div>
                    <div class="fs-3 fw-bold">{{ metrics.totalOrderValue | currency }}</div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Invoices Pending Review</div>
                    <div class="fs-3 fw-bold">{{ metrics.pendingInvoices }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="row g-3 mb-4">
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Unmatched Invoices</div>
                    <div class="fs-3 fw-bold">{{ metrics.unmatchedInvoices }}</div>
                    <a routerLink="/purchasing/invoicing" class="small">View invoicing</a>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Open Quotes</div>
                    <div class="fs-3 fw-bold">{{ metrics.openQuotes }}</div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Clean Matches</div>
                    <div class="fs-3 fw-bold">{{ metrics.cleanMatches }}</div>
                    <a routerLink="/purchasing/reconciliation" class="small">View reconciliation</a>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Unresolved Variances</div>
                    <div class="fs-3 fw-bold">{{ metrics.varianceMatches }}</div>
                    <a routerLink="/purchasing/reconciliation" class="small">Review queue</a>
                </div>
            </div>
        </div>
    </div>

    <div class="row g-3 mb-4">
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Qty Variances</div>
                    <div class="fs-3 fw-bold">{{ metrics.quantityVariances }}</div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Price Variances</div>
                    <div class="fs-3 fw-bold">{{ metrics.priceVariances }}</div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Invoices On Hold</div>
                    <div class="fs-3 fw-bold">{{ metrics.invoicesOnHold }}</div>
                    <a routerLink="/purchasing/reconciliation" class="small">View on hold</a>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Approved (Pending Payment)</div>
                    <div class="fs-3 fw-bold">{{ metrics.approvedPendingPayment }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="card purchasing-table-card-header">
        <div class="card-header">Orders by Status</div>
        <table class="table table-sm mb-0">
                <thead>
                    <tr>
                        <th>Status</th>
                        <th class="text-end">Count</th>
                        <th class="text-end">Value</th>
                    </tr>
                </thead>
                <tbody>
                    @for (bucket of metrics.ordersByStatus; track bucket.status) {
                        <tr>
                            <td>{{ bucket.status }}</td>
                            <td class="text-end">{{ bucket.count }}</td>
                            <td class="text-end">{{ bucket.total | currency }}</td>
                        </tr>
                    }
                    @if (metrics.ordersByStatus.length === 0) {
                        <tr>
                            <td colspan="3" class="text-center text-muted py-3">No purchase orders yet.</td>
                        </tr>
                    }
                </tbody>
            </table>
    </div>
} @else {
    <p class="text-muted">Loading metrics...</p>
}
